import React, { useRef } from 'react';

import Box from '@cobalt/react-box';
import Tag from '@cobalt/react-tag';
import usePosition, { CardinalPoint } from '@cobalt/react-position-hook';

import withContainer from '../hoc/withContainer';

export interface BadgeProps {
  count: number;
  children: React.ReactNode;
  size?: 'tiny' | 'small' | 'medium' | 'large';
  origin?: CardinalPoint;
  direction?: CardinalPoint;
  gapX?: number;
  gapY?: number;
  autoGap?: number;
}

const Badge = (props: BadgeProps) => {
  const { count, children, size = 'tiny', origin = 'NE', direction = 'N', gapX = 0, gapY = 10, autoGap = 0 } = props;

  const wrapRef = useRef<HTMLDivElement>(null);

  const { position } = usePosition(wrapRef.current, {
    origin,
    direction,
    gapX,
    gapY,
    autoGap,
  });

  return (
    <>
      <Box forwardedRef={wrapRef}>{children}</Box>
      <Tag color="theme" size={size} style={{ ...position }}>
        {count}
      </Tag>
    </>
  );
};

export default withContainer(Badge);
